// components/ui/Button.jsx
import React from 'react';
import { Button as MuiButton, Box } from '@mui/material';
import { keyframes } from '@emotion/react';

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export const Button = ({ 
  children, 
  variant = 'contained', 
  animate = false, 
  glow = false,
  ...props 
}) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <MuiButton
        variant={variant}
        {...props}
        sx={{
          background: variant === 'contained' 
            ? 'linear-gradient(45deg, #8b0000, #ff4d4d)'
            : 'transparent',
          border: variant === 'outlined' ? '2px solid #8b0000' : 'none',
          color: variant === 'outlined' ? '#ff4d4d' : 'white',
          fontWeight: 600,
          px: 3,
          py: 1.5,
          borderRadius: 2,
          animation: animate ? `${pulseAnimation} 2s infinite` : 'none',
          boxShadow: glow ? '0 0 20px rgba(139, 0, 0, 0.4)' : 'none',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
            transition: 'left 0.5s ease',
          },
          '&:hover::before': {
            left: '100%',
          },
          '&:hover': {
            background: variant === 'contained' 
              ? 'linear-gradient(45deg, #ff4d4d, #8b0000)'
              : 'rgba(139, 0, 0, 0.1)',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(139, 0, 0, 0.4)',
          },
          transition: 'all 0.3s ease',
          ...props.sx,
        }}
      >
        {children}
      </MuiButton>
    </Box>
  );
};



